var map = {
	"./de-DE/accordion-blocks.json": [
		57187,
		57187
	],
	"./de-DE/apps.json": [
		82383,
		82383
	],
	"./de-DE/bulk-creator.json": [
		19395,
		19395
	],
	"./de-DE/business.json": [
		36946,
		36946
	],
	"./de-DE/contact-us.json": [
		54383,
		54383
	],
	"./de-DE/cookies-policy.json": [
		50893,
		50893
	],
	"./de-DE/coupon.json": [
		81665,
		81665
	],
	"./de-DE/dashboard-alerts.json": [
		86225,
		86225
	],
	"./de-DE/email.json": [
		78212,
		78212
	],
	"./de-DE/error.json": [
		5062,
		5062
	],
	"./de-DE/event.json": [
		21385,
		21385
	],
	"./de-DE/facilities.json": [
		25432,
		25432
	],
	"./de-DE/faq.json": [
		25825,
		25825
	],
	"./de-DE/feedback.json": [
		68123,
		68123
	],
	"./de-DE/forgot-password.json": [
		20070,
		20070
	],
	"./de-DE/frames.json": [
		49771,
		49771
	],
	"./de-DE/generic-errors.json": [
		18308,
		18308
	],
	"./de-DE/home.json": [
		8654,
		8654
	],
	"./de-DE/image.json": [
		93480,
		93480
	],
	"./de-DE/impressum.json": [
		93690,
		93690
	],
	"./de-DE/inactive.json": [
		15469,
		15469
	],
	"./de-DE/layout.json": [
		23768,
		23768
	],
	"./de-DE/listoflinks.json": [
		85211,
		85211
	],
	"./de-DE/login.json": [
		71188,
		71188
	],
	"./de-DE/mp3.json": [
		97914,
		97914
	],
	"./de-DE/my-account.json": [
		70145,
		70145
	],
	"./de-DE/my-billing.json": [
		70713,
		70713
	],
	"./de-DE/my-qr-analytics.json": [
		93993,
		93993
	],
	"./de-DE/my-qr-code-details.json": [
		1595,
		1595
	],
	"./de-DE/my-qr-code-reviews.json": [
		32482,
		32482
	],
	"./de-DE/my-qr-codes.json": [
		37431,
		37431
	],
	"./de-DE/not-found.json": [
		6269,
		6269
	],
	"./de-DE/pagination.json": [
		39781,
		39781
	],
	"./de-DE/payment.json": [
		96453,
		96453
	],
	"./de-DE/pdf-qr-code.json": [
		87082,
		87082
	],
	"./de-DE/pdf.json": [
		83316,
		83316
	],
	"./de-DE/pricing.json": [
		3050,
		3050
	],
	"./de-DE/privacy-policy.json": [
		72311,
		72311
	],
	"./de-DE/qr-code-generator.json": [
		49210,
		49210
	],
	"./de-DE/qr-design-ai.json": [
		3558,
		3558
	],
	"./de-DE/qr-design.json": [
		17737,
		17737
	],
	"./de-DE/qr-editor-layout.json": [
		91126,
		91126
	],
	"./de-DE/qr-editor-stats.json": [
		53208,
		53208
	],
	"./de-DE/qr-editor.json": [
		2855,
		2855
	],
	"./de-DE/qr-types.json": [
		2133,
		2133
	],
	"./de-DE/qrcreator-dev-scan-tool.json": [
		98787,
		98787
	],
	"./de-DE/register.json": [
		67734,
		67734
	],
	"./de-DE/reset-password.json": [
		92507,
		92507
	],
	"./de-DE/set-password.json": [
		6945,
		6945
	],
	"./de-DE/sidebar.json": [
		67939,
		67939
	],
	"./de-DE/sms.json": [
		44599,
		44599
	],
	"./de-DE/social.json": [
		55166,
		55166
	],
	"./de-DE/status.json": [
		43150,
		43150
	],
	"./de-DE/template-editor.json": [
		71267,
		71267
	],
	"./de-DE/templates.json": [
		71974,
		71974
	],
	"./de-DE/terms-and-conditions.json": [
		30993,
		30993
	],
	"./de-DE/terms-of-use.json": [
		36371,
		36371
	],
	"./de-DE/text.json": [
		5839,
		5839
	],
	"./de-DE/thank-you.json": [
		29545,
		29545
	],
	"./de-DE/time-picker.json": [
		62074,
		62074
	],
	"./de-DE/unsubscribe-confirmation.json": [
		92176,
		92176
	],
	"./de-DE/unsubscribe-reasons.json": [
		21519,
		21519
	],
	"./de-DE/unsubscribe.json": [
		88095,
		88095
	],
	"./de-DE/url-static.json": [
		21983,
		21983
	],
	"./de-DE/url.json": [
		73903,
		73903
	],
	"./de-DE/users.json": [
		76485,
		76485
	],
	"./de-DE/validations.json": [
		55177,
		55177
	],
	"./de-DE/vcard-qr-code.json": [
		65592,
		65592
	],
	"./de-DE/vcard.json": [
		70194,
		70194
	],
	"./de-DE/verify-payment.json": [
		50638,
		50638
	],
	"./de-DE/video.json": [
		96046,
		96046
	],
	"./de-DE/website.json": [
		50218,
		50218
	],
	"./de-DE/whatsapp.json": [
		54863,
		54863
	],
	"./de-DE/who-we-are.json": [
		29149,
		29149
	],
	"./de-DE/wifi.json": [
		12628,
		12628
	],
	"./de-DE/youtube.json": [
		48674,
		48674
	],
	"./diff/de-DE/coupon.json": [
		29161,
		29161
	],
	"./diff/de-DE/image.json": [
		21801,
		21801
	],
	"./diff/de-DE/mp3.json": [
		66257,
		66257
	],
	"./diff/de-DE/pdf.json": [
		61708,
		61708
	],
	"./diff/de-DE/social.json": [
		75623,
		75623
	],
	"./diff/de-DE/video.json": [
		14837,
		14837
	],
	"./diff/en-US/coupon.json": [
		80896,
		80896
	],
	"./diff/en-US/image.json": [
		8272,
		8272
	],
	"./diff/en-US/mp3.json": [
		6524,
		6524
	],
	"./diff/en-US/pdf.json": [
		46574,
		46574
	],
	"./diff/en-US/social.json": [
		84326,
		84326
	],
	"./diff/en-US/video.json": [
		79741,
		79741
	],
	"./diff/es-ES/coupon.json": [
		7863,
		7863
	],
	"./diff/es-ES/image.json": [
		75534,
		75534
	],
	"./diff/es-ES/mp3.json": [
		72137,
		72137
	],
	"./diff/es-ES/pdf.json": [
		5246,
		5246
	],
	"./diff/es-ES/social.json": [
		85239,
		85239
	],
	"./diff/es-ES/video.json": [
		1347,
		1347
	],
	"./diff/fr-FR/coupon.json": [
		96361,
		96361
	],
	"./diff/fr-FR/image.json": [
		35583,
		35583
	],
	"./diff/fr-FR/mp3.json": [
		91462,
		91462
	],
	"./diff/fr-FR/pdf.json": [
		34457,
		34457
	],
	"./diff/fr-FR/social.json": [
		37600,
		37600
	],
	"./diff/fr-FR/video.json": [
		21184,
		21184
	],
	"./diff/it-IT/coupon.json": [
		1346,
		1346
	],
	"./diff/it-IT/image.json": [
		84499,
		84499
	],
	"./diff/it-IT/mp3.json": [
		65369,
		65369
	],
	"./diff/it-IT/pdf.json": [
		932,
		932
	],
	"./diff/it-IT/social.json": [
		90661,
		90661
	],
	"./diff/it-IT/video.json": [
		14323,
		14323
	],
	"./diff/ja-JP/coupon.json": [
		25469,
		78162
	],
	"./diff/ja-JP/image.json": [
		87166,
		87166
	],
	"./diff/ja-JP/mp3.json": [
		98288,
		98288
	],
	"./diff/ja-JP/pdf.json": [
		48372,
		48372
	],
	"./diff/ja-JP/social.json": [
		23827,
		23827
	],
	"./diff/ja-JP/video.json": [
		53698,
		53698
	],
	"./diff/ko-KR/coupon.json": [
		43376,
		43376
	],
	"./diff/ko-KR/image.json": [
		48782,
		48782
	],
	"./diff/ko-KR/mp3.json": [
		47811,
		47811
	],
	"./diff/ko-KR/pdf.json": [
		21975,
		21975
	],
	"./diff/ko-KR/social.json": [
		6655,
		6655
	],
	"./diff/ko-KR/video.json": [
		3253,
		3253
	],
	"./diff/pt-BR/coupon.json": [
		21195,
		21195
	],
	"./diff/pt-BR/image.json": [
		50837,
		50837
	],
	"./diff/pt-BR/mp3.json": [
		40539,
		40539
	],
	"./diff/pt-BR/pdf.json": [
		81959,
		81959
	],
	"./diff/pt-BR/social.json": [
		86332,
		86332
	],
	"./diff/pt-BR/video.json": [
		26510,
		26510
	],
	"./diff/zh-TW/coupon.json": [
		18304,
		18304
	],
	"./diff/zh-TW/image.json": [
		70162,
		70162
	],
	"./diff/zh-TW/mp3.json": [
		5147,
		5147
	],
	"./diff/zh-TW/pdf.json": [
		98526,
		98526
	],
	"./diff/zh-TW/social.json": [
		61592,
		61592
	],
	"./diff/zh-TW/video.json": [
		91249,
		91249
	],
	"./en-US/accordion-blocks.json": [
		13169,
		13169
	],
	"./en-US/apps.json": [
		99028,
		99028
	],
	"./en-US/bulk-creator.json": [
		29324,
		29324
	],
	"./en-US/business.json": [
		51337,
		51337
	],
	"./en-US/contact-us.json": [
		76726,
		76726
	],
	"./en-US/cookies-policy.json": [
		69928,
		69928
	],
	"./en-US/coupon.json": [
		82538,
		82538
	],
	"./en-US/dashboard-alerts.json": [
		3343,
		3343
	],
	"./en-US/email.json": [
		59058,
		59058
	],
	"./en-US/error.json": [
		68330,
		68330
	],
	"./en-US/event.json": [
		59604,
		59604
	],
	"./en-US/facilities.json": [
		45755,
		43257
	],
	"./en-US/faq.json": [
		79978,
		79978
	],
	"./en-US/feedback.json": [
		80655,
		80655
	],
	"./en-US/forgot-password.json": [
		67526,
		67526
	],
	"./en-US/frames.json": [
		58151,
		58151
	],
	"./en-US/generic-errors.json": [
		56857,
		56857
	],
	"./en-US/home.json": [
		62943,
		70527
	],
	"./en-US/image.json": [
		196,
		196
	],
	"./en-US/inactive.json": [
		48506,
		48506
	],
	"./en-US/layout.json": [
		93688,
		93688
	],
	"./en-US/listoflinks.json": [
		85927,
		85927
	],
	"./en-US/login.json": [
		24069,
		24069
	],
	"./en-US/mp3.json": [
		42096,
		42096
	],
	"./en-US/my-account.json": [
		63452,
		63452
	],
	"./en-US/my-billing.json": [
		55734,
		55734
	],
	"./en-US/my-qr-analytics.json": [
		39274,
		39274
	],
	"./en-US/my-qr-code-details.json": [
		66929,
		66929
	],
	"./en-US/my-qr-code-reviews.json": [
		43371,
		43371
	],
	"./en-US/my-qr-codes.json": [
		24134,
		24134
	],
	"./en-US/not-found.json": [
		52938,
		52938
	],
	"./en-US/pagination.json": [
		67936,
		67936
	],
	"./en-US/payment.json": [
		25242,
		25242
	],
	"./en-US/pdf-qr-code.json": [
		448,
		448
	],
	"./en-US/pdf.json": [
		8639,
		8639
	],
	"./en-US/pricing.json": [
		66957,
		66957
	],
	"./en-US/privacy-policy.json": [
		21326,
		21326
	],
	"./en-US/qr-code-generator.json": [
		16868,
		16868
	],
	"./en-US/qr-design-ai.json": [
		11441,
		11441
	],
	"./en-US/qr-design.json": [
		61216,
		61216
	],
	"./en-US/qr-editor-layout.json": [
		33251,
		33251
	],
	"./en-US/qr-editor-stats.json": [
		57271,
		57271
	],
	"./en-US/qr-editor.json": [
		45960,
		45960
	],
	"./en-US/qr-types.json": [
		11442,
		11442
	],
	"./en-US/qrcreator-dev-scan-tool.json": [
		40380,
		40380
	],
	"./en-US/register.json": [
		82964,
		82964
	],
	"./en-US/reset-password.json": [
		78,
		78
	],
	"./en-US/set-password.json": [
		12393,
		12393
	],
	"./en-US/sidebar.json": [
		5045,
		5045
	],
	"./en-US/sms.json": [
		71753,
		71753
	],
	"./en-US/social.json": [
		84721,
		84721
	],
	"./en-US/status.json": [
		7101,
		7101
	],
	"./en-US/template-editor.json": [
		81423,
		81423
	],
	"./en-US/templates.json": [
		58417,
		58417
	],
	"./en-US/terms-and-conditions.json": [
		99461,
		99461
	],
	"./en-US/terms-of-use.json": [
		25732,
		25732
	],
	"./en-US/text.json": [
		98409,
		98409
	],
	"./en-US/thank-you.json": [
		91488,
		91488
	],
	"./en-US/time-picker.json": [
		88714,
		88714
	],
	"./en-US/unsubscribe-confirmation.json": [
		78858,
		78858
	],
	"./en-US/unsubscribe-reasons.json": [
		23352,
		23352
	],
	"./en-US/unsubscribe.json": [
		22693,
		22693
	],
	"./en-US/url-static.json": [
		26927,
		26927
	],
	"./en-US/url.json": [
		20783,
		20783
	],
	"./en-US/users.json": [
		96665,
		96665
	],
	"./en-US/validations.json": [
		33462,
		33462
	],
	"./en-US/vcard-qr-code.json": [
		90810,
		90810
	],
	"./en-US/vcard.json": [
		19694,
		19694
	],
	"./en-US/verify-payment.json": [
		16578,
		16578
	],
	"./en-US/video.json": [
		66853,
		66853
	],
	"./en-US/website.json": [
		97357,
		97357
	],
	"./en-US/whatsapp.json": [
		20761,
		20761
	],
	"./en-US/who-we-are.json": [
		93605,
		93605
	],
	"./en-US/wifi.json": [
		4275,
		4275
	],
	"./en-US/youtube.json": [
		28584,
		28584
	],
	"./es-ES/accordion-blocks.json": [
		48051,
		48051
	],
	"./es-ES/apps.json": [
		66971,
		66971
	],
	"./es-ES/bulk-creator.json": [
		79779,
		79779
	],
	"./es-ES/business.json": [
		72774,
		72774
	],
	"./es-ES/contact-us.json": [
		90816,
		90816
	],
	"./es-ES/cookies-policy.json": [
		15115,
		15115
	],
	"./es-ES/coupon.json": [
		63737,
		63737
	],
	"./es-ES/dashboard-alerts.json": [
		4531,
		4531
	],
	"./es-ES/email.json": [
		87031,
		87031
	],
	"./es-ES/error.json": [
		93478,
		93478
	],
	"./es-ES/event.json": [
		68965,
		68965
	],
	"./es-ES/facilities.json": [
		20996,
		20996
	],
	"./es-ES/faq.json": [
		48671,
		48671
	],
	"./es-ES/feedback.json": [
		15400,
		15400
	],
	"./es-ES/forgot-password.json": [
		39187,
		39187
	],
	"./es-ES/frames.json": [
		60764,
		60764
	],
	"./es-ES/generic-errors.json": [
		84476,
		84476
	],
	"./es-ES/home.json": [
		28192,
		28192
	],
	"./es-ES/image.json": [
		18768,
		18768
	],
	"./es-ES/inactive.json": [
		90507,
		90507
	],
	"./es-ES/layout.json": [
		38066,
		38066
	],
	"./es-ES/listoflinks.json": [
		85281,
		85281
	],
	"./es-ES/login.json": [
		45398,
		45398
	],
	"./es-ES/mp3.json": [
		17299,
		17299
	],
	"./es-ES/my-account.json": [
		79282,
		93079
	],
	"./es-ES/my-billing.json": [
		49631,
		49631
	],
	"./es-ES/my-qr-analytics.json": [
		32850,
		32850
	],
	"./es-ES/my-qr-code-details.json": [
		94203,
		94203
	],
	"./es-ES/my-qr-code-reviews.json": [
		71890,
		71890
	],
	"./es-ES/my-qr-codes.json": [
		16115,
		16115
	],
	"./es-ES/not-found.json": [
		63580,
		63580
	],
	"./es-ES/pagination.json": [
		69731,
		69731
	],
	"./es-ES/payment.json": [
		4024,
		4024
	],
	"./es-ES/pdf-qr-code.json": [
		74735,
		74735
	],
	"./es-ES/pdf.json": [
		74519,
		74519
	],
	"./es-ES/pricing.json": [
		69709,
		75744
	],
	"./es-ES/privacy-policy.json": [
		39299,
		39299
	],
	"./es-ES/qr-code-generator.json": [
		71568,
		71568
	],
	"./es-ES/qr-design-ai.json": [
		81531,
		81531
	],
	"./es-ES/qr-design.json": [
		83731,
		83731
	],
	"./es-ES/qr-editor-layout.json": [
		96178,
		96178
	],
	"./es-ES/qr-editor-stats.json": [
		5099,
		5099
	],
	"./es-ES/qr-editor.json": [
		62725,
		62725
	],
	"./es-ES/qr-types.json": [
		70600,
		70600
	],
	"./es-ES/qrcreator-dev-scan-tool.json": [
		49725,
		49725
	],
	"./es-ES/register.json": [
		37746,
		37746
	],
	"./es-ES/reset-password.json": [
		64856,
		64856
	],
	"./es-ES/set-password.json": [
		78771,
		78771
	],
	"./es-ES/sidebar.json": [
		72191,
		72191
	],
	"./es-ES/sms.json": [
		22235,
		22235
	],
	"./es-ES/social.json": [
		55939,
		55939
	],
	"./es-ES/status.json": [
		89459,
		89459
	],
	"./es-ES/template-editor.json": [
		88421,
		88421
	],
	"./es-ES/templates.json": [
		9011,
		9011
	],
	"./es-ES/terms-and-conditions.json": [
		21709,
		21709
	],
	"./es-ES/terms-of-use.json": [
		95206,
		95206
	],
	"./es-ES/text.json": [
		76593,
		76593
	],
	"./es-ES/thank-you.json": [
		33953,
		33953
	],
	"./es-ES/time-picker.json": [
		19656,
		19656
	],
	"./es-ES/unsubscribe-confirmation.json": [
		85769,
		85769
	],
	"./es-ES/unsubscribe-reasons.json": [
		87015,
		87015
	],
	"./es-ES/unsubscribe.json": [
		89098,
		89098
	],
	"./es-ES/url-static.json": [
		98131,
		98131
	],
	"./es-ES/url.json": [
		14110,
		14110
	],
	"./es-ES/users.json": [
		83932,
		83932
	],
	"./es-ES/validations.json": [
		37894,
		37894
	],
	"./es-ES/vcard-qr-code.json": [
		97700,
		97700
	],
	"./es-ES/vcard.json": [
		87972,
		87972
	],
	"./es-ES/verify-payment.json": [
		92826,
		92826
	],
	"./es-ES/video.json": [
		78931,
		78931
	],
	"./es-ES/website.json": [
		19840,
		19840
	],
	"./es-ES/whatsapp.json": [
		56163,
		56163
	],
	"./es-ES/who-we-are.json": [
		15596,
		15596
	],
	"./es-ES/wifi.json": [
		14070,
		91252
	],
	"./es-ES/youtube.json": [
		28763,
		28763
	],
	"./fr-FR/accordion-blocks.json": [
		66950,
		66950
	],
	"./fr-FR/apps.json": [
		17754,
		17754
	],
	"./fr-FR/bulk-creator.json": [
		7017,
		7017
	],
	"./fr-FR/business.json": [
		84876,
		84876
	],
	"./fr-FR/contact-us.json": [
		10169,
		10169
	],
	"./fr-FR/cookies-policy.json": [
		27265,
		27265
	],
	"./fr-FR/coupon.json": [
		50738,
		50738
	],
	"./fr-FR/dashboard-alerts.json": [
		95698,
		95698
	],
	"./fr-FR/email.json": [
		82002,
		82002
	],
	"./fr-FR/error.json": [
		61244,
		61244
	],
	"./fr-FR/event.json": [
		20545,
		20545
	],
	"./fr-FR/facilities.json": [
		24492,
		24492
	],
	"./fr-FR/faq.json": [
		34241,
		34241
	],
	"./fr-FR/feedback.json": [
		99328,
		99328
	],
	"./fr-FR/forgot-password.json": [
		84989,
		84989
	],
	"./fr-FR/frames.json": [
		72526,
		72526
	],
	"./fr-FR/generic-errors.json": [
		1095,
		1095
	],
	"./fr-FR/home.json": [
		62681,
		62681
	],
	"./fr-FR/image.json": [
		85003,
		85003
	],
	"./fr-FR/inactive.json": [
		72438,
		72438
	],
	"./fr-FR/layout.json": [
		72841,
		72841
	],
	"./fr-FR/listoflinks.json": [
		45306,
		2103
	],
	"./fr-FR/login.json": [
		32249,
		32249
	],
	"./fr-FR/mp3.json": [
		6254,
		6254
	],
	"./fr-FR/my-account.json": [
		94625,
		94625
	],
	"./fr-FR/my-billing.json": [
		320,
		320
	],
	"./fr-FR/my-qr-analytics.json": [
		59153,
		59153
	],
	"./fr-FR/my-qr-code-details.json": [
		4679,
		4679
	],
	"./fr-FR/my-qr-code-reviews.json": [
		73944,
		73944
	],
	"./fr-FR/my-qr-codes.json": [
		36718,
		36718
	],
	"./fr-FR/not-found.json": [
		82109,
		82109
	],
	"./fr-FR/pagination.json": [
		27599,
		27599
	],
	"./fr-FR/payment.json": [
		15397,
		15397
	],
	"./fr-FR/pdf-qr-code.json": [
		18952,
		18952
	],
	"./fr-FR/pdf.json": [
		74146,
		74146
	],
	"./fr-FR/pricing.json": [
		16889,
		16889
	],
	"./fr-FR/privacy-policy.json": [
		45905,
		45905
	],
	"./fr-FR/qr-code-generator.json": [
		61467,
		61467
	],
	"./fr-FR/qr-design-ai.json": [
		6701,
		6701
	],
	"./fr-FR/qr-design.json": [
		92645,
		92645
	],
	"./fr-FR/qr-editor-layout.json": [
		92434,
		92434
	],
	"./fr-FR/qr-editor-stats.json": [
		40679,
		40679
	],
	"./fr-FR/qr-editor.json": [
		11795,
		11795
	],
	"./fr-FR/qr-types.json": [
		17956,
		17956
	],
	"./fr-FR/qrcreator-dev-scan-tool.json": [
		34865,
		34865
	],
	"./fr-FR/register.json": [
		92627,
		92627
	],
	"./fr-FR/reset-password.json": [
		91230,
		91230
	],
	"./fr-FR/set-password.json": [
		55289,
		55289
	],
	"./fr-FR/sidebar.json": [
		54418,
		54418
	],
	"./fr-FR/sms.json": [
		18389,
		18389
	],
	"./fr-FR/social.json": [
		98103,
		98103
	],
	"./fr-FR/status.json": [
		29174,
		29174
	],
	"./fr-FR/template-editor.json": [
		75796,
		75796
	],
	"./fr-FR/templates.json": [
		5966,
		5966
	],
	"./fr-FR/terms-and-conditions.json": [
		77161,
		77161
	],
	"./fr-FR/terms-of-use.json": [
		95964,
		95964
	],
	"./fr-FR/text.json": [
		81260,
		81260
	],
	"./fr-FR/thank-you.json": [
		2230,
		2230
	],
	"./fr-FR/time-picker.json": [
		92981,
		92981
	],
	"./fr-FR/unsubscribe-confirmation.json": [
		36377,
		36377
	],
	"./fr-FR/unsubscribe-reasons.json": [
		18532,
		18532
	],
	"./fr-FR/unsubscribe.json": [
		38118,
		38118
	],
	"./fr-FR/url-static.json": [
		76056,
		76056
	],
	"./fr-FR/url.json": [
		87346,
		87346
	],
	"./fr-FR/users.json": [
		32884,
		32884
	],
	"./fr-FR/validations.json": [
		67504,
		81935
	],
	"./fr-FR/vcard-qr-code.json": [
		89221,
		89221
	],
	"./fr-FR/vcard.json": [
		42970,
		42970
	],
	"./fr-FR/verify-payment.json": [
		7169,
		7169
	],
	"./fr-FR/video.json": [
		73967,
		73967
	],
	"./fr-FR/website.json": [
		60459,
		60459
	],
	"./fr-FR/whatsapp.json": [
		45815,
		45815
	],
	"./fr-FR/who-we-are.json": [
		64654,
		64654
	],
	"./fr-FR/wifi.json": [
		77898,
		77898
	],
	"./fr-FR/youtube.json": [
		10182,
		10182
	],
	"./it-IT/accordion-blocks.json": [
		55500,
		55500
	],
	"./it-IT/apps.json": [
		7267,
		7267
	],
	"./it-IT/bulk-creator.json": [
		35869,
		35869
	],
	"./it-IT/business.json": [
		78109,
		78109
	],
	"./it-IT/contact-us.json": [
		83755,
		83755
	],
	"./it-IT/cookies-policy.json": [
		25845,
		25845
	],
	"./it-IT/coupon.json": [
		84587,
		84587
	],
	"./it-IT/dashboard-alerts.json": [
		7170,
		7170
	],
	"./it-IT/email.json": [
		48353,
		48353
	],
	"./it-IT/error.json": [
		54435,
		54435
	],
	"./it-IT/event.json": [
		85826,
		85826
	],
	"./it-IT/facilities.json": [
		73115,
		73115
	],
	"./it-IT/faq.json": [
		97067,
		97067
	],
	"./it-IT/feedback.json": [
		60556,
		60556
	],
	"./it-IT/forgot-password.json": [
		37433,
		37433
	],
	"./it-IT/frames.json": [
		99120,
		99120
	],
	"./it-IT/generic-errors.json": [
		9710,
		9710
	],
	"./it-IT/home.json": [
		79453,
		79453
	],
	"./it-IT/image.json": [
		97767,
		97767
	],
	"./it-IT/inactive.json": [
		45455,
		45455
	],
	"./it-IT/layout.json": [
		25940,
		25940
	],
	"./it-IT/listoflinks.json": [
		87727,
		87727
	],
	"./it-IT/login.json": [
		38295,
		38295
	],
	"./it-IT/mp3.json": [
		44965,
		44965
	],
	"./it-IT/my-account.json": [
		50742,
		50742
	],
	"./it-IT/my-billing.json": [
		81730,
		81730
	],
	"./it-IT/my-qr-analytics.json": [
		40858,
		40858
	],
	"./it-IT/my-qr-code-details.json": [
		43539,
		43539
	],
	"./it-IT/my-qr-code-reviews.json": [
		55677,
		55677
	],
	"./it-IT/my-qr-codes.json": [
		59202,
		59202
	],
	"./it-IT/not-found.json": [
		54252,
		54252
	],
	"./it-IT/pagination.json": [
		90588,
		90588
	],
	"./it-IT/payment.json": [
		94974,
		94974
	],
	"./it-IT/pdf-qr-code.json": [
		82657,
		82657
	],
	"./it-IT/pdf.json": [
		68876,
		68876
	],
	"./it-IT/pricing.json": [
		42996,
		42996
	],
	"./it-IT/privacy-policy.json": [
		17427,
		17427
	],
	"./it-IT/qr-code-generator.json": [
		52273,
		52273
	],
	"./it-IT/qr-design-ai.json": [
		70721,
		70721
	],
	"./it-IT/qr-design.json": [
		19812,
		19812
	],
	"./it-IT/qr-editor-layout.json": [
		30708,
		30708
	],
	"./it-IT/qr-editor-stats.json": [
		48699,
		48699
	],
	"./it-IT/qr-editor.json": [
		45157,
		45157
	],
	"./it-IT/qr-types.json": [
		14400,
		14400
	],
	"./it-IT/qrcreator-dev-scan-tool.json": [
		9750,
		9750
	],
	"./it-IT/register.json": [
		33327,
		33327
	],
	"./it-IT/reset-password.json": [
		18078,
		18078
	],
	"./it-IT/set-password.json": [
		60727,
		60727
	],
	"./it-IT/sidebar.json": [
		45738,
		45738
	],
	"./it-IT/sms.json": [
		59486,
		59486
	],
	"./it-IT/social.json": [
		73017,
		73017
	],
	"./it-IT/status.json": [
		82563,
		82563
	],
	"./it-IT/template-editor.json": [
		52346,
		52346
	],
	"./it-IT/templates.json": [
		26003,
		26003
	],
	"./it-IT/terms-and-conditions.json": [
		1435,
		1435
	],
	"./it-IT/terms-of-use.json": [
		12822,
		12822
	],
	"./it-IT/text.json": [
		14195,
		14195
	],
	"./it-IT/thank-you.json": [
		21406,
		21406
	],
	"./it-IT/time-picker.json": [
		94981,
		94981
	],
	"./it-IT/unsubscribe-confirmation.json": [
		36740,
		36740
	],
	"./it-IT/unsubscribe-reasons.json": [
		66798,
		66798
	],
	"./it-IT/unsubscribe.json": [
		11260,
		11260
	],
	"./it-IT/url-static.json": [
		95567,
		95567
	],
	"./it-IT/url.json": [
		86565,
		86565
	],
	"./it-IT/users.json": [
		59098,
		59098
	],
	"./it-IT/validations.json": [
		88218,
		88218
	],
	"./it-IT/vcard-qr-code.json": [
		94969,
		94969
	],
	"./it-IT/vcard.json": [
		41097,
		41097
	],
	"./it-IT/verify-payment.json": [
		87379,
		87379
	],
	"./it-IT/video.json": [
		80785,
		80785
	],
	"./it-IT/website.json": [
		32298,
		32298
	],
	"./it-IT/whatsapp.json": [
		77165,
		77165
	],
	"./it-IT/who-we-are.json": [
		15564,
		15564
	],
	"./it-IT/wifi.json": [
		84508,
		84508
	],
	"./it-IT/youtube.json": [
		61509,
		61509
	],
	"./ja-JP/accordion-blocks.json": [
		8364,
		8364
	],
	"./ja-JP/apps.json": [
		79111,
		79111
	],
	"./ja-JP/bulk-creator.json": [
		30926,
		30926
	],
	"./ja-JP/business.json": [
		50741,
		50741
	],
	"./ja-JP/contact-us.json": [
		83705,
		83705
	],
	"./ja-JP/cookies-policy.json": [
		49731,
		49731
	],
	"./ja-JP/coupon.json": [
		50422,
		50422
	],
	"./ja-JP/dashboard-alerts.json": [
		7105,
		7105
	],
	"./ja-JP/email.json": [
		13311,
		13311
	],
	"./ja-JP/error.json": [
		78038,
		78038
	],
	"./ja-JP/event.json": [
		43146,
		43146
	],
	"./ja-JP/facilities.json": [
		46486,
		46486
	],
	"./ja-JP/faq.json": [
		85314,
		85314
	],
	"./ja-JP/feedback.json": [
		21065,
		21065
	],
	"./ja-JP/forgot-password.json": [
		34341,
		34341
	],
	"./ja-JP/frames.json": [
		65176,
		65176
	],
	"./ja-JP/generic-errors.json": [
		8903,
		8903
	],
	"./ja-JP/home.json": [
		98020,
		98020
	],
	"./ja-JP/image.json": [
		376,
		376
	],
	"./ja-JP/inactive.json": [
		3941,
		3941
	],
	"./ja-JP/layout.json": [
		80046,
		80046
	],
	"./ja-JP/listoflinks.json": [
		2585,
		2585
	],
	"./ja-JP/login.json": [
		78086,
		78086
	],
	"./ja-JP/mp3.json": [
		5763,
		5763
	],
	"./ja-JP/my-account.json": [
		77443,
		77443
	],
	"./ja-JP/my-billing.json": [
		64074,
		64074
	],
	"./ja-JP/my-qr-analytics.json": [
		47280,
		58490
	],
	"./ja-JP/my-qr-code-details.json": [
		98398,
		98398
	],
	"./ja-JP/my-qr-code-reviews.json": [
		26806,
		26806
	],
	"./ja-JP/my-qr-codes.json": [
		90094,
		90094
	],
	"./ja-JP/not-found.json": [
		27890,
		27890
	],
	"./ja-JP/pagination.json": [
		85684,
		85684
	],
	"./ja-JP/payment.json": [
		91431,
		91431
	],
	"./ja-JP/pdf-qr-code.json": [
		3278,
		3278
	],
	"./ja-JP/pdf.json": [
		9648,
		9648
	],
	"./ja-JP/pricing.json": [
		28920,
		28920
	],
	"./ja-JP/privacy-policy.json": [
		10432,
		10432
	],
	"./ja-JP/qr-code-generator.json": [
		23019,
		23019
	],
	"./ja-JP/qr-design-ai.json": [
		47841,
		47841
	],
	"./ja-JP/qr-design.json": [
		500,
		500
	],
	"./ja-JP/qr-editor-layout.json": [
		77292,
		77292
	],
	"./ja-JP/qr-editor-stats.json": [
		98886,
		98886
	],
	"./ja-JP/qr-editor.json": [
		77248,
		77248
	],
	"./ja-JP/qr-types.json": [
		40167,
		40167
	],
	"./ja-JP/qrcreator-dev-scan-tool.json": [
		76387,
		76387
	],
	"./ja-JP/register.json": [
		85466,
		85466
	],
	"./ja-JP/reset-password.json": [
		63800,
		19713
	],
	"./ja-JP/set-password.json": [
		72977,
		72977
	],
	"./ja-JP/sidebar.json": [
		29447,
		29447
	],
	"./ja-JP/sms.json": [
		10091,
		10091
	],
	"./ja-JP/social.json": [
		47335,
		47335
	],
	"./ja-JP/status.json": [
		48912,
		48912
	],
	"./ja-JP/template-editor.json": [
		67647,
		67647
	],
	"./ja-JP/templates.json": [
		67107,
		67107
	],
	"./ja-JP/terms-and-conditions.json": [
		25893,
		25893
	],
	"./ja-JP/terms-of-use.json": [
		52570,
		46859
	],
	"./ja-JP/text.json": [
		66,
		66
	],
	"./ja-JP/thank-you.json": [
		34826,
		34826
	],
	"./ja-JP/time-picker.json": [
		69640,
		69640
	],
	"./ja-JP/unsubscribe-confirmation.json": [
		82341,
		82341
	],
	"./ja-JP/unsubscribe-reasons.json": [
		98562,
		98562
	],
	"./ja-JP/unsubscribe.json": [
		51534,
		51534
	],
	"./ja-JP/url-static.json": [
		95298,
		95298
	],
	"./ja-JP/url.json": [
		11669,
		11669
	],
	"./ja-JP/users.json": [
		44153,
		44153
	],
	"./ja-JP/validations.json": [
		48158,
		48158
	],
	"./ja-JP/vcard-qr-code.json": [
		30531,
		30531
	],
	"./ja-JP/vcard.json": [
		32147,
		32147
	],
	"./ja-JP/verify-payment.json": [
		15176,
		15176
	],
	"./ja-JP/video.json": [
		82702,
		82702
	],
	"./ja-JP/website.json": [
		11312,
		11312
	],
	"./ja-JP/whatsapp.json": [
		21339,
		21339
	],
	"./ja-JP/who-we-are.json": [
		85896,
		85896
	],
	"./ja-JP/wifi.json": [
		21432,
		21432
	],
	"./ja-JP/youtube.json": [
		86112,
		86112
	],
	"./ko-KR/accordion-blocks.json": [
		88576,
		88576
	],
	"./ko-KR/apps.json": [
		44240,
		44240
	],
	"./ko-KR/bulk-creator.json": [
		15642,
		15642
	],
	"./ko-KR/business.json": [
		49406,
		49406
	],
	"./ko-KR/contact-us.json": [
		94872,
		94872
	],
	"./ko-KR/cookies-policy.json": [
		82045,
		82045
	],
	"./ko-KR/coupon.json": [
		20289,
		20289
	],
	"./ko-KR/dashboard-alerts.json": [
		33816,
		33816
	],
	"./ko-KR/email.json": [
		16475,
		16475
	],
	"./ko-KR/error.json": [
		54536,
		54536
	],
	"./ko-KR/event.json": [
		44845,
		44845
	],
	"./ko-KR/facilities.json": [
		57384,
		57384
	],
	"./ko-KR/faq.json": [
		15852,
		15852
	],
	"./ko-KR/feedback.json": [
		45516,
		45516
	],
	"./ko-KR/forgot-password.json": [
		52129,
		52129
	],
	"./ko-KR/frames.json": [
		97838,
		97838
	],
	"./ko-KR/generic-errors.json": [
		76577,
		76577
	],
	"./ko-KR/home.json": [
		19819,
		19819
	],
	"./ko-KR/image.json": [
		86308,
		86308
	],
	"./ko-KR/inactive.json": [
		35912,
		35912
	],
	"./ko-KR/layout.json": [
		98240,
		98240
	],
	"./ko-KR/listoflinks.json": [
		34750,
		34750
	],
	"./ko-KR/login.json": [
		73540,
		73540
	],
	"./ko-KR/mp3.json": [
		16654,
		16654
	],
	"./ko-KR/my-account.json": [
		30020,
		30020
	],
	"./ko-KR/my-billing.json": [
		64165,
		64165
	],
	"./ko-KR/my-qr-analytics.json": [
		36129,
		36129
	],
	"./ko-KR/my-qr-code-details.json": [
		44696,
		44696
	],
	"./ko-KR/my-qr-code-reviews.json": [
		37460,
		37460
	],
	"./ko-KR/my-qr-codes.json": [
		61917,
		61917
	],
	"./ko-KR/not-found.json": [
		15545,
		15545
	],
	"./ko-KR/pagination.json": [
		24286,
		24286
	],
	"./ko-KR/payment.json": [
		49962,
		49962
	],
	"./ko-KR/pdf-qr-code.json": [
		29145,
		29145
	],
	"./ko-KR/pdf.json": [
		66413,
		66413
	],
	"./ko-KR/pricing.json": [
		35315,
		35315
	],
	"./ko-KR/privacy-policy.json": [
		8360,
		8360
	],
	"./ko-KR/qr-code-generator.json": [
		53766,
		53766
	],
	"./ko-KR/qr-design-ai.json": [
		15376,
		15376
	],
	"./ko-KR/qr-design.json": [
		78417,
		78417
	],
	"./ko-KR/qr-editor-layout.json": [
		98267,
		98267
	],
	"./ko-KR/qr-editor-stats.json": [
		40872,
		40872
	],
	"./ko-KR/qr-editor.json": [
		85464,
		85464
	],
	"./ko-KR/qr-types.json": [
		81632,
		81632
	],
	"./ko-KR/qrcreator-dev-scan-tool.json": [
		50875,
		50875
	],
	"./ko-KR/register.json": [
		35228,
		35228
	],
	"./ko-KR/reset-password.json": [
		99250,
		99250
	],
	"./ko-KR/set-password.json": [
		13732,
		13732
	],
	"./ko-KR/sidebar.json": [
		96772,
		96772
	],
	"./ko-KR/sms.json": [
		71765,
		71765
	],
	"./ko-KR/social.json": [
		43490,
		43490
	],
	"./ko-KR/status.json": [
		50277,
		50277
	],
	"./ko-KR/template-editor.json": [
		27891,
		27891
	],
	"./ko-KR/templates.json": [
		27567,
		27567
	],
	"./ko-KR/terms-and-conditions.json": [
		42948,
		42948
	],
	"./ko-KR/terms-of-use.json": [
		75220,
		75220
	],
	"./ko-KR/text.json": [
		66060,
		66060
	],
	"./ko-KR/thank-you.json": [
		13712,
		41932
	],
	"./ko-KR/time-picker.json": [
		38357,
		38357
	],
	"./ko-KR/unsubscribe-confirmation.json": [
		44406,
		44406
	],
	"./ko-KR/unsubscribe-reasons.json": [
		2886,
		2886
	],
	"./ko-KR/unsubscribe.json": [
		65545,
		65545
	],
	"./ko-KR/url-static.json": [
		80970,
		80970
	],
	"./ko-KR/url.json": [
		11269,
		11269
	],
	"./ko-KR/users.json": [
		51132,
		51132
	],
	"./ko-KR/validations.json": [
		78829,
		78829
	],
	"./ko-KR/vcard-qr-code.json": [
		73610,
		73610
	],
	"./ko-KR/vcard.json": [
		58148,
		58148
	],
	"./ko-KR/verify-payment.json": [
		10399,
		10399
	],
	"./ko-KR/video.json": [
		6435,
		6435
	],
	"./ko-KR/website.json": [
		30482,
		30482
	],
	"./ko-KR/whatsapp.json": [
		4916,
		4916
	],
	"./ko-KR/who-we-are.json": [
		31085,
		31085
	],
	"./ko-KR/wifi.json": [
		51792,
		51792
	],
	"./ko-KR/youtube.json": [
		92817,
		92817
	],
	"./nl-nl/coupon.json": [
		52025,
		52025
	],
	"./nl-nl/event.json": [
		84562,
		84562
	],
	"./nl-nl/image.json": [
		79481,
		79481
	],
	"./nl-nl/login.json": [
		32206,
		32206
	],
	"./nl-nl/pdf.json": [
		1045,
		1045
	],
	"./nl-nl/qrcreator-dev-scan-tool.json": [
		60169,
		60169
	],
	"./nl-nl/register.json": [
		72708,
		72708
	],
	"./nl-nl/url-static.json": [
		1312,
		1312
	],
	"./nl-nl/url.json": [
		24547,
		24547
	],
	"./nl-nl/vcard.json": [
		79861,
		79861
	],
	"./pl-pl/coupon.json": [
		49010,
		49010
	],
	"./pl-pl/event.json": [
		33185,
		33185
	],
	"./pl-pl/image.json": [
		43357,
		43357
	],
	"./pl-pl/login.json": [
		43722,
		43722
	],
	"./pl-pl/pdf.json": [
		91702,
		91702
	],
	"./pl-pl/qrcreator-dev-scan-tool.json": [
		9937,
		9937
	],
	"./pl-pl/register.json": [
		67731,
		67731
	],
	"./pl-pl/url-static.json": [
		99989,
		99989
	],
	"./pl-pl/url.json": [
		64406,
		64406
	],
	"./pl-pl/vcard.json": [
		78195,
		78195
	],
	"./pt-BR/accordion-blocks.json": [
		34184,
		34184
	],
	"./pt-BR/apps.json": [
		28043,
		28043
	],
	"./pt-BR/bulk-creator.json": [
		44815,
		44815
	],
	"./pt-BR/business.json": [
		16015,
		16015
	],
	"./pt-BR/contact-us.json": [
		34663,
		34663
	],
	"./pt-BR/cookies-policy.json": [
		78415,
		78415
	],
	"./pt-BR/coupon.json": [
		80672,
		80672
	],
	"./pt-BR/dashboard-alerts.json": [
		14747,
		14747
	],
	"./pt-BR/email.json": [
		71446,
		71446
	],
	"./pt-BR/error.json": [
		381,
		381
	],
	"./pt-BR/event.json": [
		34029,
		34029
	],
	"./pt-BR/facilities.json": [
		14097,
		14097
	],
	"./pt-BR/faq.json": [
		95220,
		95220
	],
	"./pt-BR/feedback.json": [
		76461,
		76461
	],
	"./pt-BR/forgot-password.json": [
		99043,
		99043
	],
	"./pt-BR/frames.json": [
		64649,
		64649
	],
	"./pt-BR/generic-errors.json": [
		27197,
		27197
	],
	"./pt-BR/home.json": [
		35192,
		35192
	],
	"./pt-BR/image.json": [
		18302,
		18302
	],
	"./pt-BR/inactive.json": [
		13085,
		13085
	],
	"./pt-BR/layout.json": [
		72074,
		72074
	],
	"./pt-BR/listoflinks.json": [
		47937,
		47937
	],
	"./pt-BR/login.json": [
		36286,
		36286
	],
	"./pt-BR/mp3.json": [
		15561,
		15561
	],
	"./pt-BR/my-account.json": [
		30032,
		30032
	],
	"./pt-BR/my-billing.json": [
		35331,
		35331
	],
	"./pt-BR/my-qr-analytics.json": [
		67041,
		67041
	],
	"./pt-BR/my-qr-code-details.json": [
		6167,
		6167
	],
	"./pt-BR/my-qr-code-reviews.json": [
		33742,
		33742
	],
	"./pt-BR/my-qr-codes.json": [
		44028,
		44028
	],
	"./pt-BR/not-found.json": [
		62667,
		62667
	],
	"./pt-BR/pagination.json": [
		36298,
		36298
	],
	"./pt-BR/payment.json": [
		29382,
		29382
	],
	"./pt-BR/pdf-qr-code.json": [
		57878,
		57878
	],
	"./pt-BR/pdf.json": [
		42421,
		42421
	],
	"./pt-BR/pricing.json": [
		65729,
		65729
	],
	"./pt-BR/privacy-policy.json": [
		32669,
		32669
	],
	"./pt-BR/qr-code-generator.json": [
		1964,
		1964
	],
	"./pt-BR/qr-design-ai.json": [
		62616,
		62616
	],
	"./pt-BR/qr-design.json": [
		21085,
		21085
	],
	"./pt-BR/qr-editor-layout.json": [
		53956,
		53956
	],
	"./pt-BR/qr-editor-stats.json": [
		23149,
		23149
	],
	"./pt-BR/qr-editor.json": [
		67484,
		67484
	],
	"./pt-BR/qr-types.json": [
		31441,
		31441
	],
	"./pt-BR/qrcreator-dev-scan-tool.json": [
		9309,
		9309
	],
	"./pt-BR/register.json": [
		93065,
		93065
	],
	"./pt-BR/reset-password.json": [
		58622,
		58622
	],
	"./pt-BR/set-password.json": [
		82752,
		82752
	],
	"./pt-BR/sidebar.json": [
		33564,
		33564
	],
	"./pt-BR/sms.json": [
		68400,
		68400
	],
	"./pt-BR/social.json": [
		59272,
		59272
	],
	"./pt-BR/status.json": [
		49062,
		49062
	],
	"./pt-BR/template-editor.json": [
		854,
		854
	],
	"./pt-BR/templates.json": [
		33227,
		33227
	],
	"./pt-BR/terms-and-conditions.json": [
		18608,
		40292
	],
	"./pt-BR/terms-of-use.json": [
		28147,
		28147
	],
	"./pt-BR/text.json": [
		56673,
		56673
	],
	"./pt-BR/thank-you.json": [
		72241,
		72241
	],
	"./pt-BR/time-picker.json": [
		50732,
		50732
	],
	"./pt-BR/unsubscribe-confirmation.json": [
		37043,
		37043
	],
	"./pt-BR/unsubscribe-reasons.json": [
		27514,
		27514
	],
	"./pt-BR/unsubscribe.json": [
		54932,
		54932
	],
	"./pt-BR/url-static.json": [
		55980,
		55980
	],
	"./pt-BR/url.json": [
		60647,
		60647
	],
	"./pt-BR/users.json": [
		41615,
		41615
	],
	"./pt-BR/validations.json": [
		27994,
		27994
	],
	"./pt-BR/vcard-qr-code.json": [
		39335,
		39335
	],
	"./pt-BR/vcard.json": [
		91549,
		91549
	],
	"./pt-BR/verify-payment.json": [
		43708,
		62943
	],
	"./pt-BR/video.json": [
		58598,
		58598
	],
	"./pt-BR/website.json": [
		61564,
		61564
	],
	"./pt-BR/whatsapp.json": [
		43135,
		43135
	],
	"./pt-BR/who-we-are.json": [
		45283,
		45283
	],
	"./pt-BR/wifi.json": [
		3888,
		3888
	],
	"./pt-BR/youtube.json": [
		99218,
		99218
	],
	"./sv-se/coupon.json": [
		30351,
		30351
	],
	"./sv-se/event.json": [
		13962,
		13962
	],
	"./sv-se/image.json": [
		3606,
		3606
	],
	"./sv-se/login.json": [
		25924,
		25924
	],
	"./sv-se/pdf.json": [
		62859,
		62859
	],
	"./sv-se/qrcreator-dev-scan-tool.json": [
		74,
		74
	],
	"./sv-se/register.json": [
		4807,
		4807
	],
	"./sv-se/url-static.json": [
		51556,
		51556
	],
	"./sv-se/url.json": [
		33242,
		33242
	],
	"./sv-se/vcard.json": [
		67042,
		67042
	],
	"./tr-tr/coupon.json": [
		3811,
		3811
	],
	"./tr-tr/event.json": [
		32457,
		32457
	],
	"./tr-tr/image.json": [
		43309,
		90097
	],
	"./tr-tr/login.json": [
		74656,
		74656
	],
	"./tr-tr/pdf.json": [
		89409,
		89409
	],
	"./tr-tr/qrcreator-dev-scan-tool.json": [
		1697,
		1697
	],
	"./tr-tr/register.json": [
		5625,
		5625
	],
	"./tr-tr/url-static.json": [
		59001,
		59001
	],
	"./tr-tr/url.json": [
		67770,
		67770
	],
	"./tr-tr/vcard.json": [
		33873,
		90728
	],
	"./zh-TW/accordion-blocks.json": [
		33345,
		33345
	],
	"./zh-TW/apps.json": [
		344,
		344
	],
	"./zh-TW/bulk-creator.json": [
		89983,
		89983
	],
	"./zh-TW/business.json": [
		59999,
		59999
	],
	"./zh-TW/contact-us.json": [
		40151,
		40151
	],
	"./zh-TW/cookies-policy.json": [
		29030,
		29030
	],
	"./zh-TW/coupon.json": [
		13778,
		13778
	],
	"./zh-TW/dashboard-alerts.json": [
		44878,
		44878
	],
	"./zh-TW/email.json": [
		53295,
		322
	],
	"./zh-TW/error.json": [
		12283,
		12283
	],
	"./zh-TW/event.json": [
		12715,
		12715
	],
	"./zh-TW/facilities.json": [
		97841,
		97841
	],
	"./zh-TW/faq.json": [
		44191,
		44191
	],
	"./zh-TW/feedback.json": [
		10665,
		10665
	],
	"./zh-TW/forgot-password.json": [
		4534,
		4534
	],
	"./zh-TW/frames.json": [
		55660,
		55660
	],
	"./zh-TW/generic-errors.json": [
		17928,
		17928
	],
	"./zh-TW/home.json": [
		91671,
		91671
	],
	"./zh-TW/image.json": [
		84064,
		84064
	],
	"./zh-TW/inactive.json": [
		36641,
		36641
	],
	"./zh-TW/layout.json": [
		12684,
		12684
	],
	"./zh-TW/listoflinks.json": [
		90120,
		90120
	],
	"./zh-TW/login.json": [
		32025,
		32025
	],
	"./zh-TW/mp3.json": [
		16677,
		16677
	],
	"./zh-TW/my-account.json": [
		18429,
		18429
	],
	"./zh-TW/my-billing.json": [
		67846,
		67846
	],
	"./zh-TW/my-qr-analytics.json": [
		61465,
		61465
	],
	"./zh-TW/my-qr-code-details.json": [
		54839,
		54839
	],
	"./zh-TW/my-qr-code-reviews.json": [
		53968,
		53968
	],
	"./zh-TW/my-qr-codes.json": [
		83898,
		83898
	],
	"./zh-TW/not-found.json": [
		60951,
		60951
	],
	"./zh-TW/pagination.json": [
		62011,
		62011
	],
	"./zh-TW/payment.json": [
		49433,
		49433
	],
	"./zh-TW/pdf-qr-code.json": [
		51652,
		51652
	],
	"./zh-TW/pdf.json": [
		4143,
		4143
	],
	"./zh-TW/pricing.json": [
		79495,
		79495
	],
	"./zh-TW/privacy-policy.json": [
		55897,
		55897
	],
	"./zh-TW/qr-code-generator.json": [
		3321,
		3321
	],
	"./zh-TW/qr-design-ai.json": [
		89246,
		89246
	],
	"./zh-TW/qr-design.json": [
		29390,
		29390
	],
	"./zh-TW/qr-editor-layout.json": [
		72732,
		72732
	],
	"./zh-TW/qr-editor-stats.json": [
		45063,
		45063
	],
	"./zh-TW/qr-editor.json": [
		3311,
		3311
	],
	"./zh-TW/qr-types.json": [
		40448,
		40448
	],
	"./zh-TW/qrcreator-dev-scan-tool.json": [
		47065,
		47065
	],
	"./zh-TW/register.json": [
		19615,
		19615
	],
	"./zh-TW/reset-password.json": [
		54166,
		54166
	],
	"./zh-TW/set-password.json": [
		74949,
		74949
	],
	"./zh-TW/sidebar.json": [
		49850,
		49850
	],
	"./zh-TW/sms.json": [
		17138,
		17138
	],
	"./zh-TW/social.json": [
		88616,
		88616
	],
	"./zh-TW/status.json": [
		71262,
		71262
	],
	"./zh-TW/template-editor.json": [
		64975,
		64975
	],
	"./zh-TW/templates.json": [
		78714,
		78714
	],
	"./zh-TW/terms-and-conditions.json": [
		10543,
		10543
	],
	"./zh-TW/terms-of-use.json": [
		43207,
		43207
	],
	"./zh-TW/text.json": [
		9584,
		9584
	],
	"./zh-TW/thank-you.json": [
		22023,
		22023
	],
	"./zh-TW/time-picker.json": [
		14728,
		14728
	],
	"./zh-TW/unsubscribe-confirmation.json": [
		61900,
		61900
	],
	"./zh-TW/unsubscribe-reasons.json": [
		94772,
		94772
	],
	"./zh-TW/unsubscribe.json": [
		11408,
		11408
	],
	"./zh-TW/url-static.json": [
		17234,
		17234
	],
	"./zh-TW/url.json": [
		50930,
		50930
	],
	"./zh-TW/users.json": [
		59071,
		59071
	],
	"./zh-TW/validations.json": [
		8405,
		8405
	],
	"./zh-TW/vcard-qr-code.json": [
		63022,
		63022
	],
	"./zh-TW/vcard.json": [
		22707,
		22707
	],
	"./zh-TW/verify-payment.json": [
		592,
		592
	],
	"./zh-TW/video.json": [
		65536,
		65536
	],
	"./zh-TW/website.json": [
		99672,
		99672
	],
	"./zh-TW/whatsapp.json": [
		25911,
		25911
	],
	"./zh-TW/who-we-are.json": [
		66111,
		66111
	],
	"./zh-TW/wifi.json": [
		64990,
		64990
	],
	"./zh-TW/youtube.json": [
		15119,
		15119
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 37645;
module.exports = webpackAsyncContext;